<div class="container">

  <div class="grid container-header">
    <div class="col-12 md:col-12 lg:col-6">
      <span class="title">{{'TRANSLATE.REPORTS' | translate}}</span>
    </div>
  </div>

  <div class="container-body">

    @if (blockedUi) {
      <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
        <i class="pi pi-spin pi-spinner" style="font-size: 60px;font-weight: bold"></i>
      </div>
    }


    <form class="reports-form" [formGroup]="userform" (ngSubmit)="exportExcel()">

      <div class="product-itens">

        <div class="report-field">
          <div class="element-edit">
            <label class="element-edit-label" for="country">{{ 'TRANSLATE.COUNTRY' | translate }}</label>
            <p-dropdown formControlName="optionCountry" [options]="listCountries" id="country"
              placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
              (onChange)="countryChange($event)" [style]="{'minWidth': '100%'}" panelStyleClass="reports-dropdown-panel" appendTo="body" #countryDropdown>
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{item?.label | translate}}
              </ng-template>
            </p-dropdown>

            @if (selectedCountry === null && userform.controls['optionCountry'].invalid) {
              <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.SELECT.COUNTRY' | translate }}"
                >
              </p-message>
            }
          </div>
        </div>

        <div class="report-message" id="countryNotBra"
          [ngClass]="{'showItems': selectedCountry && !isBrazilSelected, 'hideItems': !selectedCountry || isBrazilSelected}">

          <div class="message-edit" role="status" aria-live="polite">
            <i class="pi pi-info-circle" aria-hidden="true"></i>
            <p>{{'TRANSLATE.CURRENTLY.NO.REPORTS.COUNTRY' | translate }}</p>
          </div>
        </div>

        <div class="report-field"
          [ngClass]="{'showItems': isBrazilSelected, 'hideItems': !isBrazilSelected}">

          <div class="element-edit">
            <label class="element-edit-label" for="reportType">{{ 'TRANSLATE.REPORT.TYPE' | translate }}</label>
            <p-dropdown formControlName="optionReportType" [options]="listReportType" id="reportType"
              placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
              (onChange)="reportTypeChange($event)" [style]="{'minWidth': '100%'}" panelStyleClass="reports-dropdown-panel" appendTo="body" #reportTypeDropdown>
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{item?.label | translate}}
              </ng-template>
            </p-dropdown>

            @if (selectedReportType === null && userform.controls['optionReportType'].invalid) {
              <p-message class="client-data-message" severity="error"
                text="{{ 'TRANSLATE.SELECT.REPORT.TYPE' | translate }}"
                >
              </p-message>
            }
          </div>
        </div>

        <div class="report-field"
          [ngClass]="{'showItems': isBrazilSelected && selectedReportType === invoice, 'hideItems': !isBrazilSelected || selectedReportType !== invoice}">
          <div class="element-edit">
            <label class="element-edit-label" for="month">{{ 'TRANSLATE.MONTH' | translate }}</label>
            <p-dropdown formControlName="optionMonth" [options]="listMonths" id="month" (onChange)="monthChange($event)"
              placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
              [style]="{'minWidth': '100%'}" panelStyleClass="reports-dropdown-panel" appendTo="body" #monthDropdown>
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{item?.label | translate}}
              </ng-template>
            </p-dropdown>

            @if (selectedMonth === null && userform.controls['optionMonth'].invalid) {
              <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.SELECT.MONTH' | translate }}"
                >
              </p-message>
            }
          </div>
        </div>

        <div class="report-field"
          [ngClass]="{'showItems': isBrazilSelected && selectedReportType === invoice, 'hideItems': !isBrazilSelected || selectedReportType !== invoice}">
          <div class="element-edit">
            <label class="element-edit-label" for="year">{{ 'TRANSLATE.YEAR' | translate }}</label>
            <p-dropdown formControlName="optionYear" [options]="listYear" id="year" (onChange)="yearChange($event)"
              placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
              [style]="{'minWidth': '100%'}" panelStyleClass="reports-dropdown-panel" appendTo="body" #yearDropdown>
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{item?.label | translate}}
              </ng-template>
            </p-dropdown>

            @if (selectedYear === null && userform.controls['optionYear'].invalid) {
              <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.SELECT.YEAR' | translate }}"
                >
              </p-message>
            }
          </div>
        </div>

      </div>

      <div class="button-position">

        <button id="btnClean" class="btn-pattern app-clean-button" type="button" (click)="buttonClean()" [disabled]="blockedUi">
          <i class="pi pi-trash"></i>
          <span class="action-button-label">{{ 'TRANSLATE.BNT.CLEAR' | translate }}</span>
        </button>

        <button id="btnExportExcel" class="btn-pattern app-filter-button" type="submit" [disabled]="blockedUi || !canExport" [attr.aria-busy]="blockedUi">
          <i [ngClass]="blockedUi ? 'pi pi-spin pi-spinner' : 'pi pi-file-excel'" aria-hidden="true"></i>
          <span class="action-button-label">{{ (blockedUi ? 'TRANSLATE.EXPORTING.EXCEL' : 'TRANSLATE.EXPORT.EXCEL') | translate }}</span>
        </button>

      </div>

    </form>
  </div>
</div>
